import { useCallback } from 'react';
import CheckboxDropdown from './CheckboxDropdown';
import '../styles/advanced-filter.css';

export default function AdvancedFilterPanel({
  fields = [],
  values = {},
  onFieldChange,
  onClear,
  clearLabel = 'フィルタークリア',
  filterMode = 'AND',
  onFilterModeChange,
}) {
  const getOptions = useCallback(
    (field) => {
      if (typeof field.getOptions === 'function') {
        return field.getOptions({ values }) || [];
      }
      return field.options || [];
    },
    [values],
  );

  const toOptionObject = (option) => {
    if (option && typeof option === 'object') {
      return { value: option.value ?? '', label: option.label ?? option.value ?? '' };
    }
    return { value: option ?? '', label: option ?? '' };
  };

  return (
    <div className="pm-filters pm-filters--advanced">
      {/* AND/OR トグル */}
      {typeof onFilterModeChange === 'function' && (
        <div className="pm-filter-mode-toggle">
          <button
            className={filterMode === 'AND' ? 'is-active' : ''}
            onClick={() => onFilterModeChange('AND')}
            type="button"
          >
            AND
          </button>
          <button
            className={filterMode === 'OR' ? 'is-active' : ''}
            onClick={() => onFilterModeChange('OR')}
            type="button"
          >
            OR
          </button>
        </div>
      )}

      {fields.map((field) => {
        const fieldValue = values[field.key];

        if (field.type === 'multiselect') {
          const options = getOptions(field).map(toOptionObject);
          return (
            <CheckboxDropdown
              className={field.className}
              key={field.key}
              label={field.label}
              onChange={(vals) => onFieldChange && onFieldChange(field.key, vals)}
              options={options}
              selectedValues={Array.isArray(fieldValue) ? fieldValue : []}
            />
          );
        }

        // date / text
        const inputValue = fieldValue ?? '';
        const fieldClassName = ['pm-filter-item', field.className].filter(Boolean).join(' ');

        return (
          <label className={fieldClassName} key={field.key}>
            {field.label}
            <input
              className="pm-filter-input"
              onChange={(e) => onFieldChange && onFieldChange(field.key, e.target.value)}
              placeholder={field.placeholder || ''}
              type={field.type || 'text'}
              value={inputValue}
            />
          </label>
        );
      })}

      {typeof onClear === 'function' && (
        <button className="pm-filter-clear" onClick={onClear} type="button">
          {clearLabel}
        </button>
      )}
    </div>
  );
}
